import { apiClient } from "../util/ApiClient";
import {
  TRANSACTIONS_OVERVIEW_PATH,
  TRANSACTIONS_REFRESH_PATH
} from "../config/Api";

import {
  ORGANIZATION_LOADED,
  ORGANIZATION_UPDATED
} from "./organization";

export const TRANSACTIONS_OVERVIEW_LOADED = "TRANSACTIONS_OVERVIEW_LOADED";
export const transactionsOverviewLoaded = overview => ({
  type: TRANSACTIONS_OVERVIEW_LOADED,
  payload: overview
});

export const TRANSACTIONS_REFRESHED = "TRANSACTIONS_REFRESHED";
export const transactionsRefreshed = data => ({
  type: TRANSACTIONS_REFRESHED,
  payload: data
});

export const REQUEST_OPEN_TRANSACTION_MODAL = "REQUEST_OPEN_TRANSACTION_MODAL";
export const requestOpenTransactionModal = transactionUUID => ({
  type: REQUEST_OPEN_TRANSACTION_MODAL,
  transactionUUID
});

export const REQUEST_CLOSE_TRANSACTION_MODAL =
  "REQUEST_CLOSE_TRANSACTION_MODAL";
export const requestCloseTransactionModal = () => ({
  type: REQUEST_CLOSE_TRANSACTION_MODAL
});

const transactionsInitialState = {
  plaid_connected: false,
  waiting_for_plaid: false,
  bank_errors: false,
  pending_transactions: [],
  transactions: [],
  openedTransactionModal: null
};
export const transactionsReducer = (
  state = transactionsInitialState,
  action
) => {
  switch (action.type) {
    case TRANSACTIONS_OVERVIEW_LOADED:
      return {
        ...state,
        ...action.payload
      };
    case TRANSACTIONS_REFRESHED:
      return {
        ...state,
        pending_transactions: action.payload.pending_transactions,
        transactions: action.payload.transactions,
        waiting_for_plaid: action.payload.waiting_for_plaid,
        bank_errors: action.payload.bank_errors
      };
    case REQUEST_OPEN_TRANSACTION_MODAL:
      return {
        ...state,
        openedTransactionModal: action.transactionUUID
      };
    case REQUEST_CLOSE_TRANSACTION_MODAL:
      return {
        ...state,
        openedTransactionModal: null
      };
    case ORGANIZATION_LOADED:
    case ORGANIZATION_UPDATED:
      return {
        ...state,
        plaid_connected: action.organization.bank_credentials.length > 0,
        waiting_for_plaid: action.organization.bank_credentials.some((bank) => bank.status === 'initial_wait'),
        bank_errors: action.organization.bank_credentials.some((bank) => bank.status === 'error'),
      }
    default:
      return state;
  }
};

export const loadTransactionsOverview = () => {
  return apiClient()
    .get(TRANSACTIONS_OVERVIEW_PATH)
    .then(response => response.data);
};

export const refreshTransactions = () => {
  return apiClient()
    .post(TRANSACTIONS_REFRESH_PATH)
    .then(response => response.data);
};



// WEBPACK FOOTER //
// ./frontend/src/actions/transactions.js